import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { ContentFiltersKeys } from '../ContentFilters';
import { getNoDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { Users } from '../../../userManagement/services/resources/Users';

export const SearchUserDefinition: ExplorableItemDefinition = {
  itemType: 'searchuser',
  pluralName: Messages.users,
  emptyStateMessage: Messages.usersEmptyMessage,
  contentFilterKeys: [ContentFiltersKeys.search],
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['searchuser']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Users.instance.all().withExtraParams({
      'getItemCounts': true
    });
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
